<ng-container *ngIf="!loaded; else content">
  <boma-anim-spinning-loader [size]="60"></boma-anim-spinning-loader>
  <p class="text-center">Loading Orders</p>
</ng-container>

<ng-template #content>
  <boma-crud-table
    (changePageClicked)="handleChangePageClicked($event)"
    (queryChanged)="handleSearchQueryChanged($event)"
    (filterSelected)="handleFilterSelectionChange($event)"
    [data]="orders"
    [filterLabel]="'Status'"
    [filters]="statusTypeOptions"
    [locationFilter]="false"
    [paginationData]="pagination"
    [searchBarPlaceHolder]="'Search Reference Number'"
    [selectableColumns]="columns"
    [singleLocation]="false"
    [viewPath]="'/orders/order/detail/'"
    [viewable]="true"
    [loaded]="loaded"
    [queryParam]="query"
    [displaySearchBar]="true"
  >
  </boma-crud-table>
</ng-template>
